var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"comp-banner",style:(_vm.data.pic ? 'background-image:url(' + _vm.data.pic + ')' : '')},[_c('div',{staticClass:"g-wrap"},[_c('h2',[_vm._v(_vm._s(_vm.data.name))]),_c('h3',[_vm._v(_vm._s(_vm.data.enName))])])])}
var staticRenderFns = []

export { render, staticRenderFns }